import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import FacilityBrandingPageComponent from './FacilityBrandingPage';
import { getFacilityBrandingList } from '../../../store/actions/clients';

export const FacilityBrandingPage = connect(
    (state) => ({
        facilityBrandingList: state.clients.facilityBrandingList ?? [],
        getFacilityBrandingListPending: state.clients.getFacilityBrandingList.pending,
    }),
    (dispatch) => ({
        actions: bindActionCreators({
            getFacilityBrandingList,
        }, dispatch)
    })
)(injectIntl(FacilityBrandingPageComponent));